import type { ApiClient } from '@up2d8/api-client';
import type { FeedSync } from '@up2d8/contracts';
import { LAST_SYNC_KEY, getMeta, removePost, saveFeedItems, setMeta } from './db';

/**
 * Bijwerken wat er op het toestel staat (Stap 12).
 *
 * Twee dingen, en het tweede is het belangrijkste: wat is er nieuw, en **wat mag weg**. Een ingetrokken
 * instructie die op een telefoon blijft staan, is precies de fout die intrekken hoort te voorkomen — een
 * medewerker leest dan een procedure die niet meer geldt, en niets op zijn scherm zegt dat.
 *
 * Het tijdstip komt van de server en niet van de telefoon. Met de klok van het toestel zou een telefoon
 * die vijf minuten achterloopt elke keer dezelfde berichten opnieuw halen, en een die voorloopt zou
 * wijzigingen overslaan.
 */
export async function syncFeed(api: ApiClient): Promise<{ vernieuwd: number; verwijderd: number }> {
  const since = await getMeta<string>(LAST_SYNC_KEY);

  const { data, error } = await api.GET('/api/v1/feed/sync', {
    params: { query: since ? { since } : {} },
  });
  if (error || !data) throw error ?? new Error('Bijwerken mislukt');

  const sync = data as FeedSync;

  // Eerst weghalen, dan toevoegen: bij een bericht dat ingetrokken én gewijzigd is (dat kan, een
  // intrekking is ook een wijziging) hoort weg te blijven wat weg moet.
  for (const postId of sync.removed) await removePost(postId);
  await saveFeedItems(sync.changed);
  await setMeta(LAST_SYNC_KEY, sync.serverTime);

  return { vernieuwd: sync.changed.length, verwijderd: sync.removed.length };
}
